/**
 * Created by req89873 on 11/30/16.
 */

/*
* @component: cobrand-header
* @params: property, manager, association, make-payment, property-managed, header-message
* @returns: directive with formatted HTML
*
* */

import { Component, Input, OnInit } from "@angular/core";

@Component({
    selector: 'app-cobrand-header',
    template: require('./cobrandHeader.directive.html')
})
export class CobrandHeader implements  OnInit {

    @Input() property: string;
    @Input() manager: any;
    @Input() association: any;
    @Input() makePayment: boolean;
    @Input() propertyManaged: boolean;
    @Input() headerMessage: string;

    headerMessageValue: string = "";

    constructor() {}

    ngOnInit(): void {
        this.activate();
    }

    activate() {
        if (this.makePayment) {
            this.headerMessageValue = "Payment for";
        }

        if (this.propertyManaged) {
            this.headerMessageValue = "Property Managed by";
        }

        if (this.headerMessage) {
            this.headerMessageValue = this.headerMessage;
        }
    }
}

